// extracted by mini-css-extract-plugin
export default {"tag":"lsf-tag","tag_size_small":"lsf-tag_size_small","tag_size_compact":"lsf-tag_size_compact"};
    if(module.hot) {
      // 1732531523419
      var cssReload = require("/home/kartik/kvr-lsf/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  